export default __webpack_public_path__ + "static/media/gnd_en_jing_b3.0fba4929.mp3";